import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'examples';

const EXAMPLES_ENDPOINTS = {
  listExamples: () => formatEndpoint('', namespace),
};

export default EXAMPLES_ENDPOINTS;
